import React, { useState, useRef, useEffect } from "react";
import validator from "@rjsf/validator-ajv8";
import Form from "@rjsf/mui";
import { Container, Typography, CircularProgress, Box, Button } from "@mui/material";
import { Check as CheckIcon } from "@mui/icons-material";
import FileFactory from "../customComponents/fileWidget/FileFactory";
import { addDatapoint, syncOneDatapoint } from "../../indexDB/utils/datapoint";
import QrScanner from "../datapoint/QrScanner";
import ConsentComponent from "../datapoint/Consent";

const MagicUrlDatapoint = ({ dataset, setSubmit, setDatapointId }) => {
  const [formData, setFormData] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [consentInfo, setConsentInfo] = useState(null);
  const [showConsent, setShowConsent] = useState(true);
  const [autoSaveStart, setAutoSaveStart] = useState(false);
  
  const formRef = useRef({});
  const fileData = useRef([]);
  const requiredFieldsRef = useRef([]);
  const [userDetails, setUserDetails] = useState({
    latitude: 0,
    longitude: 0,
    timestamp: 0,
});
useEffect(() => {
    setConsentInfo(dataset?.schema?.consent);
    setShowConsent(dataset?.schema?.consent ? true : false);
  }, [dataset]);

  const handleSubmit = async ({ formData }) => {
    setShowLoading(true);
    try {
      const response = await addDatapoint(formData, formRef.current, crypto.randomUUID(), userDetails);
      if (setDatapointId) {
        setDatapointId(response);
      }
      
      if (navigator.onLine) {
        try {
          await syncOneDatapoint(response);
          console.log("auto-synced datapoint");
        } catch {
          console.log("failed to auto-sync");
        }
      }

      setFormSubmitted(true);
      setTimeout(() => {
        setShowButtons(true);
        if (setSubmit) {
          setSubmit(true);
        }
      }, 1000);
    } catch (error) {
      console.error("Error submitting datapoint:", error);
    }
    setShowLoading(false);
  };

  const handleConsent = () => {
    setShowConsent(false);
    setTimeout(() => {
      setAutoSaveStart(true);
    }, 500);
  };

  const customWidgets = {
    FileWidget: (props) => (
      <FileFactory
        requiredFieldsRef={requiredFieldsRef}
        formRef={formRef}
        filesData={fileData.current}
        {...props}
      />
    ),
    QrScannerWidget: (props) => (
      <QrScanner
        questionTitle={props.schema.title}
        optionalValue={props.value}
        onChange={props.onChange}
        disabled={false}
      />
    )
  };

  const transformErrors = (errors) => {
    return errors.map((error) => {
      if (error.name === "required") {
        error.message = `${error.params.missingProperty} is mandatory`;
      }
      return error;
    });
  };

  return (
    <Container sx={{ paddingTop: { xs: "12px", sm: "16px" } }}>
      {formSubmitted ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: { xs: "100px", sm: "300px" },
          }}
        >
          <div
            style={{
              margin: "16px",
              width: "48px",
              height: "48px",
              borderRadius: "50%",
              backgroundColor: "green",
              border: "4px solid gray",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckIcon style={{ color: "white", fontSize: "28px" }} />
          </div>
          <Typography variant="body1">Form saved</Typography>
          <Typography variant="body2">Thanks for sharing your info</Typography>
        </Box>
      ) : (
        <Box>
          {showConsent ? (
            <div>
              <ConsentComponent
                handleConsent={handleConsent}
                consentInfo={consentInfo}
              />
            </div>
          ) : (
            <Box>
              {showLoading ? (
                <Box sx={{ 
                  display: "flex", 
                  justifyContent: "center",
                  alignItems: "center", 
                  gap: 2,
                  m: 2,
                  p: 3,
                  borderRadius: 1,
                  backgroundColor: (theme) => theme.palette.grey[50]
                }}>
                  <CircularProgress size={24} thickness={4} />
                  <Typography variant="body1" sx={{ color: (theme) => theme.palette.text.secondary }}>
                    Please wait while we sync your form.
                  </Typography>
                </Box>
              ) : (
                <Box sx={{ paddingTop: "10px" }}>
                  <Form
                    schema={dataset?.schema}
                    onSubmit={handleSubmit}
                    formData={formData}
                    onChange={({ formData }) => setFormData(formData)}
                    uiSchema={dataset?.schema?.ui_schema}
                    validator={validator}
                    liveValidate
                    widgets={customWidgets}
                    showErrorList=""
                    transformErrors={transformErrors}
                  />
                </Box>
              )}
            </Box>
          )}
        </Box>
      )}
    </Container>
  );
};

export default MagicUrlDatapoint; 